import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useContext } from './Context';

export default ({id, countyID, town, name, missionUA, missionEN, focusUA, 
    focusEN, contactUA, contactEN, email, link, img}) => {
    const ref = useRef(null)
    const {map: {selectedOrg}} = useContext()
    const { t, i18n: { language} } = useTranslation();
    const isUa = language === 'ua'
    const mission = isUa ? missionUA : missionEN
    const contact = isUa ? contactUA : contactEN
    const focus = isUa ? focusUA : focusEN
    const renderRow = (label, value) => {
        return value !== "N/A" ? (<Row>
            <p>
                <b>{label}: </b>
                {value}
            </p>
        </Row>): (<></>)
    }
    const renderContacts = () => {
        if (contact === 'N/A') return <></>
        let contacts = contact.split(',').join(', ')
        return <Row>
            <p>
                <b>{t("Contact")}: </b>
                {contacts}
            </p>
        </Row>
    }
    useEffect(()=>{
        if(ref && selectedOrg == id) {
            ref.current.scrollIntoView({behaviour: 'smooth'})
        }
    }, [selectedOrg,])
    return <Container ref={ref} style={{"margin-top": '20px', animation: "fadeinout 4s linear forwards"}}>
        <Row style={{alignItems: "center"}}>
            <Col md={4} style={{textAlign: "center", display: "flex", minHeight: "200px", alignItems: "center",}}>
                <img src={img} class="org-logo-full" style={{height: "auto", margin: "auto"}} />
            </Col>
            <Col>
                <Container>
                    <Row>
                        <h2>{name}</h2>
                    </Row>
                    <Row>
                        <h3>{town}</h3>
                    </Row>
                    {renderRow(t("Mission"), mission)}
                    {renderRow(t("Focus"), focus)}
                    {renderContacts()}
                    <Row>
                        <p>
                            <b>Email: </b>
                            {email.split(',').map((email => <><a href={`mailto:${email}`}>{email}</a><br/></>))}
                        </p>
                    </Row>
                    {link !== 'N/A'? (<Row>
                        <a href={link} style={{textAlign: 'center'}}><Button variant="dark"> {t("FindOutMore")}</Button></a>
                    </Row>) : <></>}
                </Container>
            </Col>
        </Row>
    </Container>
}